<template>
  <div class="box-edit d-flex" :class="{ loading: loadingRemove }">
    <div v-if="loadingRemove" class="loading-remove">
      <b-spinner variant="secondary" />
    </div>

    <img v-if="image" :src="image" class="image-icon" />
    <img v-if="image" src="@/assets/images/btn-stars.png" class="image-stars" />

    <div class="d-flex flex-column justify-content-center">
      <h6>{{ title }}</h6>
      <span class="small-text text-secondary">{{ description }}</span>
      <button
        v-if="showRemoveButton"
        type="button"
        class="btn btn-remove"
        @click="showingRemoveDialog = true"
      >
        <i class="icon-trash"></i>
      </button>
      <button type="button" class="btn btn-edit" @click="$emit('edit')">
        <i class="fa-solid fa-pen"></i>
      </button>
    </div>

    <confirmation
      v-model="showingRemoveDialog"
      iconType="warning"
      title="Tem certeza que deseja remover?"
      cancelButtonText="Cancelar"
      confirmButtonClass="btn-danger"
      confirmButtonText="Remover"
      @confirm="$emit('remove')"
      @cancel="showingRemoveDialog = false"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: null
    },
    showRemoveButton: {
      type: Boolean,
      default: false
    },
    loadingRemove: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showingRemoveDialog: false
    };
  }
};
</script>

<style lang="scss" scoped>
.box-edit {
  padding: 19px;
  border-radius: 4px;
  margin-top: 8px;
  border: 1px solid #d2d0d8;
  position: relative;

  .image-stars {
    position: absolute;
    left: 2%;
    top: 15%;
    transform: translateX(-2%);
    max-height: 70%;
  }

  .image-icon {
    max-height: 70%;
    margin-left: 8px;
    margin-right: 20px;
  }

  h6 {
    margin: 0;
  }

  button {
    min-width: 24px;
    min-height: 24px;
    max-width: 24px;
    max-height: 24px;
    background-color: #393444;
    position: absolute;
    top: 10%;
    color: #fff;

    display: flex;
    justify-content: center;
    align-items: center;

    i {
      max-width: 24px;
    }

    &.btn-edit {
      right: 8px;
    }
    &.btn-remove {
      right: 40px;
    }
  }

  .loading-remove {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.05);
  }

  &.loading {
    opacity: 0.5;
  }
}
</style>
